
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/[cName]/locations",
      function () {
        return require("private-next-pages/stores/[cName]/locations.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/[cName]/locations"])
      });
    }
  